import { render, staticRenderFns } from "./telephone.vue?vue&type=template&id=9bfa85a6&scoped=true&"
import script from "./telephone.vue?vue&type=script&lang=js&"
export * from "./telephone.vue?vue&type=script&lang=js&"
import style0 from "./telephone.vue?vue&type=style&index=0&id=9bfa85a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa85a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bfa85a6')) {
      api.createRecord('9bfa85a6', component.options)
    } else {
      api.reload('9bfa85a6', component.options)
    }
    module.hot.accept("./telephone.vue?vue&type=template&id=9bfa85a6&scoped=true&", function () {
      api.rerender('9bfa85a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/telephone.vue"
export default component.exports